import script from "./FitsHeaderTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FitsHeaderTable.vue?vue&type=script&setup=true&lang=js"

import "./FitsHeaderTable.vue?vue&type=style&index=0&id=5efc739d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5efc739d"]])

export default __exports__